import { render, staticRenderFns } from "./ManageProblem.vue?vue&type=template&id=38b4529a&scoped=true"
import script from "./ManageProblem.vue?vue&type=script&lang=js"
export * from "./ManageProblem.vue?vue&type=script&lang=js"
import style0 from "./ManageProblem.vue?vue&type=style&index=0&id=38b4529a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4529a",
  null
  
)

export default component.exports